import React from 'react';
import fr from 'facet-rest';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import TabContainer from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails/TabContainer';
import PropTypes from 'prop-types';
import { WhatIfScenarioAssumptionsClientDisclaimer } from 'Components/ComponentLibrary/Organisms/WhatIfScenarioAssumptionsClientDisclaimer';
import { FDContentContainer } from '@facet-wealth/design';
import InsightsTabContent
  from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails/TabContent/InsightsTabContent';
import OutcomesTabContent from './OutcomesTabContent';
import NextUpTabContent from './NextUpTabContent';

const tabIdMap = {
  // Planner-side
  outcomes: 'outcomes',
  insights: 'insights',
  nextUpSummary: 'nextUpSummary',
  // Member-side
  Outcomes: 'outcomes',
  Insights: 'insights',
  Actions: 'nextUpSummary',
};

const tabConfigurationMap = {
  Outcomes: {},
  outcomes: {
    backgroundColor: 'lightGray',
    Component: OutcomesTabContent,
  },
  insights: {
    backgroundColor: 'white',
    Component: InsightsTabContent,
  },
  nextUpSummary: {
    backgroundColor: 'white',
    Component: NextUpTabContent,
  },
};

const TabContent = ({
  currentTabId,
  facetPlanClientViewResource,
  facetPlanClientViewCollection,
}) => {
  const tabResourceData = facetPlanClientViewResource
    .attr('tabs')
    ?.resources()
    .findResource({ id: currentTabId, type: 'resourceTabularDetailTab' })
    .relationship(fr.relationships.tabData.name)
    .attr('data');

  if (!tabResourceData) {
    return null;
  }

  const [includedResourceIdentifier] = tabResourceData;

  const tabResource = facetPlanClientViewCollection
    .included()
    .findResource(includedResourceIdentifier);

  // If you can't find a tab resource then just return nothing
  if (!tabResource) {
    return null;
  }

  const {
    backgroundColor,
    Component,
  } = tabConfigurationMap[tabIdMap[currentTabId]];

  return (
    <StackItem
      fillsSpace
      background={backgroundColor}
    >
      <TabContainer
        collection={facetPlanClientViewCollection}
        resource={facetPlanClientViewResource}
      >
        <Component resource={tabResource} />
      </TabContainer>
      <FDContentContainer maxWidth={'sm'}>
        <WhatIfScenarioAssumptionsClientDisclaimer resource={facetPlanClientViewResource} />
      </FDContentContainer>
    </StackItem>
  );
};

TabContent.defaultProps = {};

TabContent.propTypes = {
  currentTabId: PropTypes.string.isRequired,
  facetPlanClientViewResource: PropTypes.object.isRequired,
  facetPlanClientViewCollection: PropTypes.object.isRequired,
};

export default TabContent;
